"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Memmory {
    clear() {
        this.pamiec = {};
    }
    get(id) {
        if (typeof id === typeof undefined)
            throw "MEMMORY GET UNDECLARED POINTER";
        if (typeof this.pamiec[id] === typeof undefined)
            throw "MEMMORY GET UNDECLARED MEMMORY CELL (" + id + ")";
        return this.pamiec[id];
    }
    set(id, val) {
        console.log("\tsetting " + id + " to " + val);
        if (typeof id === typeof undefined)
            throw "MEMMORY GET UNDECLARED POINTER";
        if (typeof val === typeof undefined)
            throw "MEMMORY GET UNDECLARED VALUE";
        this.pamiec[id] = val;
    }
    dump() {
        return JSON.stringify(this.pamiec);
    }
    constructor() {
        this.pamiec = {};
    }
}
exports.Memmory = Memmory;
//# sourceMappingURL=Memmory.js.map


// WEBPACK FOOTER //
// ./utilities/RM/Memmory.js